import { collab } from '@/utils'
import { CLIENT_CODE_COLLAB } from '@/constants'

import { Params, Response, ResponseDetail, Service } from '.'

const fetch = async (params: Params): Promise<Response> => {
  try {
    const res = await collab.get<Response>('redeem/product', { params: { ...params, client_code: CLIENT_CODE_COLLAB } })
    return res.data
  } catch (e) {
    throw e
  }
}

const fetchDetail = async (id: number): Promise<ResponseDetail> => {
  try {
    const res = await collab.get<ResponseDetail>(`redeem/product/${id}`, { params: { client_code: CLIENT_CODE_COLLAB } })
    return res.data
  } catch (e) {
    throw e
  }
}

export const service: Service = {
  fetch,
  fetchDetail
}
